module.exports = __webpack_public_path__ + "img/newStudentsGroupPic.d3258a9f.jpeg";